import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'tr' };

class TableRow extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-table__row',
            className,
        ];
    }

}

TableRow.propTypes = propTypes;

TableRow.defaultProps = defaultProps;

export default TableRow;
